import { fetcher } from '@commenda/utils';
import { CompanyHandlerType } from '@prisma/client';

export type TAssignHandlerItem = {
  handlerId: string;
  type: CompanyHandlerType;
};

export type TAssignHandlerToCompany = {
  companyId: number;
  handlers: TAssignHandlerItem[];
};

export async function assignHandlerToCompany(
  data: TAssignHandlerToCompany
): Promise<Response> {
  try {
    const res = await fetcher(`company/${data.companyId}/handler`, {
      method: 'POST',
      body: {
        handlers: data.handlers,
      },
    });
    return res;
  } catch (err) {
    console.error(err);
  }
}
